
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26 52c-.136-.231-3.328-5.69-3.328-7.458a3.33 3.33 0 016.659 0c0 1.768-3.192 7.226-3.328 7.458zm0-12.327a5.72 5.72 0 01-5.741-5.145H13a13.033 13.033 0 013.654-9.185A13.8 13.8 0 0116.452 23c0-8.545 2.6-14.343 4.774-17.7A19.8 19.8 0 0126 0a20.256 20.256 0 014.775 5.348c2.178 3.383 4.774 9.209 4.774 17.755a12.274 12.274 0 01-.2 2.223A13.064 13.064 0 0139 34.528h-7.26A5.72 5.72 0 0126 39.673zm0-26.206a3.98 3.98 0 104.023 3.98A4.007 4.007 0 0026 13.467z","fill":"#222"}})])
          )
        }
      }
    